module.exports = {
    expandSummaryPanel(isFolded) {
        this.view.expandOrCollapseFlightDetails(isFolded, 'expandPanel');
    },
    enableChangeSearch(show) {
        this.view.enableChangeSearch(show);
    },
    toggleFlightDetails() {
        this.view.toggleFlightDetails();
    },
    showFlightInfo: function(data) {
        this.view.$el.find('.flexibility_disruption_flight_details').addClass('odf-hidden');
        this.model.setData(data);
    },
    continueWithoutFlightInfo(data) {
        this.model.setData(data, {silent: true});
        Odigeo.trigger(`${this.id}:bookFlight`, this.model.getBookingData());
    },
    closePopup() {
        this.view.closeFlightSummary(true);
    },
    showBoardingOptions(data) {
        this.model.storeBoardingOptions(data);
        this.view.showBoardingOptions();
    },
    launchPopupMetaanc() {
        this.view.launchPopup();
    },
    renderFlexAlert: function(showPromotionalMessage) {
        if (showPromotionalMessage) {
            this.view.$el.find('.flexibility_disruption_flight_details').removeClass('odf-hidden');
        }
    },
    selectFlightAndShowIP() {
        this.view.onResultsContinueButton({upsellTouchpointClicked: true});
    },
    selectFlightWithPrimeSelection({isPrimeSelected}) {
        this.view.onResultsContinueButton({primeSubscriptionSelected: isPrimeSelected});
    },
};
